<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppButton from './AppButton';

@Component({})
export default class AppButtonReload extends AppButton {
  @Prop({ type: String, required: false, default: 'el-icon-refresh' })
  icon;

  created () {
    const resourceCode = 'common.button.reload';
    this.buttonText = this.label === '' ? this.$t(resourceCode) : this.label;
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/button/AppButtonReload.vue